import { TooltipMethods } from '@/components/tooltip/tooltip.types'

export const TOOLTIP_REF_INITIAL_VALUE: TooltipMethods = {
  handleMouseEnter: () => {},
  handleMouseLeave: () => {},
  handleMouseMove: () => {}
}
